/* Hokuro - boton + de anadir al carrito desde la coleccion */
(function(){
  if(window.hkQuickAdd)return;window.hkQuickAdd=true;
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function closeAll(except){document.querySelectorAll('.hk-qa.is-open').forEach(function(el){if(el!==except)el.classList.remove('is-open')})}
  function add(id,qa){
    if(qa.classList.contains('is-busy'))return;
    qa.classList.add('is-busy');
    fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
      .then(function(r){return r.json().then(function(d){if(!r.ok)throw d;return d})})
      .then(function(d){
        qa.classList.remove('is-open');qa.classList.add('is-added');
        setTimeout(function(){qa.classList.remove('is-added')},1600);
        if(typeof window.upcartRefreshCart==='function'){
          try{window.upcartRefreshCart()}catch(e){}
          if(typeof window.upcartOpenCart==='function'){try{window.upcartOpenCart()}catch(e){}}
        }else{
          document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:d&&d.items?d.items[0]:d}}));
        }
      })
      .catch(function(err){
        var msg=(err&&(err.description||err.message))||'Could not add to cart';
        var b=qa.querySelector('.hk-qa__btn');if(b)b.setAttribute('title',msg);
        console.warn('[hk-quick-add]',msg);
      })
      .finally(function(){qa.classList.remove('is-busy')});
  }
  document.addEventListener('click',function(e){
    var t=e.target&&e.target.closest?e.target.closest('[data-hk-qa-add],[data-hk-qa-toggle]'):null;
    if(!t){if(!(e.target&&e.target.closest&&e.target.closest('.hk-qa')))closeAll();return}
    e.preventDefault();e.stopPropagation();
    var qa=t.closest('.hk-qa');if(!qa)return;
    if(t.hasAttribute('data-hk-qa-add')){add(t.getAttribute('data-hk-qa-add'),qa);return}
    closeAll(qa);qa.classList.toggle('is-open');
  },true);
  document.addEventListener('mouseover',function(e){
    var open=document.querySelector('.hk-qa.is-open');if(!open)return;
    var card=open.closest('.grid-product');
    if(card&&!card.contains(e.target))open.classList.remove('is-open');
  });
})();
